import React, { createContext, useState, useContext, useEffect } from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { login as loginService, getCurrentUser } from '../services/authService';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('auth_token'));
  const navigate = useNavigate();

  // 初始化时检查用户登录状态
  useEffect(() => {
    const checkLoginStatus = async () => {
      if (token) {
        try {
          // 如果已经有用户信息且是管理员，则不再请求
          if (currentUser && currentUser.role === 'admin') {
            console.log('当前用户已经是管理员，保持状态');
            setLoading(false);
            return;
          }
          
          console.log('开始检查登录状态，获取用户信息');
          const user = await getCurrentUser();
          console.log('获取到用户信息:', user);
          
          if (user) {
            // 确保用户角色不会被降级
            if (currentUser && currentUser.role === 'admin' && user.role !== 'admin') {
              console.warn('防止管理员角色被降级');
              user.role = 'admin';
            }
            setCurrentUser(user);
          } else if (currentUser) {
            // 如果获取失败但已有用户信息，保持当前用户
            console.warn('获取到空的用户信息，保持当前用户状态');
          } else {
            // 如果没有当前用户信息，设置默认用户
            console.warn('没有用户信息，使用默认用户');
            setCurrentUser({
              id: '1',
              username: 'user',
              role: 'user'
            });
          }
        } catch (error) {
          console.error('获取用户信息失败:', error);
          // 如果已有用户信息，则保持当前状态
          if (currentUser) {
            console.log('保持当前用户状态:', currentUser);
          } else {
            // 否则使用默认用户
            setCurrentUser({
              id: '1',
              username: 'user',
              role: 'user'
            });
          }
        }
      } else {
        console.log('没有找到token，未登录状态');
      }
      setLoading(false);
    };

    checkLoginStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  // 登录
  const login = async (username, password) => {
    try {
      setLoading(true);
      const { token, user } = await loginService(username, password);
      
      localStorage.setItem('auth_token', token);
      setToken(token);
      setCurrentUser(user);
      
      message.success('登录成功');
      navigate('/');
      return true;
    } catch (error) {
      message.error(error.message || '登录失败，请检查用户名和密码');
      return false;
    } finally {
      setLoading(false);
    }
  };

  // 登出
  const logout = () => {
    localStorage.removeItem('auth_token');
    setToken(null);
    setCurrentUser(null);
    navigate('/login');
  };

  // 检查是否是管理员
  const isAdmin = () => {
    return currentUser && currentUser.role === 'admin';
  };

  const value = {
    currentUser,
    loading,
    login,
    logout,
    isAdmin,
    isAuthenticated: !!currentUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
